/**
 * Get portal for components that should render outside the app root
 */
const getPortalElement = (id?: string): HTMLDivElement => {
  const portalId = id ? `#${id}` : '#portal';
  const portalElem = document.body.querySelector<HTMLDivElement>(portalId);
  if (!portalElem) {
    // Create a new portal element if not found
    const newPortalElem = document.createElement('div');
    newPortalElem.id = id ?? 'portal-new';
    document.body.appendChild(newPortalElem);
    return newPortalElem;
  }

  return portalElem;
};

export default getPortalElement;
